import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=1b31f5e0&scoped=true"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31f5e0",
  null
  
)

export default component.exports